//@flow
import Logo from "./Logo";
export { Logo };